<template>
  <div class="protection-page">
    <main class="protection-card" aria-labelledby="protection-title">
      <p class="protection-eyebrow">Privacy &amp; Security</p>
      <h1 id="protection-title" class="protection-title">PACMNY Single-Page HIPAA Summary</h1>

      <p class="protection-lede">
        The PACMNY MyChart App is HIPAA-compliant, adheres to modern design principles
        and practices, and is overseen by a dedicated team of healthcare and technical
        professionals. It is made by people who care, for people who care.
      </p>

      <p>
        We're dedicated to managing and delivering critical healthcare related
        information while respecting the absolute privacy that such information
        demands. The protection of personal healthcare information falls to the
        Office for Civil Rights, under the U.S. Dept. of Health and Human Services.
        HIPAA compliance requires conformance to a sweeping and comprehensive set of
        guidelines
        (<a
          href="https://www.hhs.gov/hipaa/index.html"
          target="_blank"
          rel="noopener noreferrer"
          >hhs.gov/hipaa</a
        >).
      </p>

      <section aria-labelledby="protection-list-heading">
        <h2 id="protection-list-heading" class="protection-heading">
          Here are some of the ways we protect patient health information
        </h2>
        <ul class="protection-list">
          <li>
            Park Avenue Concierge Medicine of New York, responsible for the design and
            development of the MyChart app, offers the highest level of personalized
            medical care to select patients. The office is fully HIPAA-compliant.
          </li>
          <li>
            For patients receiving care from organizations other than PACMNY, your
            organization maintains a HIPAA Business Associate Agreement with us.
          </li>
          <li>
            Electronic patient health information ("ePHI") is stored in a database
            maintained by a world-class, enterprise-class host services provider, which
            is also HIPAA-compliant. PACMNY maintains a HIPAA Business Associate
            Agreement with this provider.
          </li>
          <li>
            All patient information is regarded as "sensitive," and remains
            fully-encrypted from the caregiver's fingers, through all points in our
            system, whether at rest or traveling to backup, until your caregiver's eyes
            return to it. Respecting the "minimum necessary" privilege model, no one may
            (or can) look at patient information without appropriate privileges.
            Sensitive patient information remains isolated even from our developers.
          </li>
          <li>
            PACMNY staff are routinely trained in proper protocol and security
            procedures, protecting against accidental disclosure and minimizing the
            likelihood of a security breach.
          </li>
        </ul>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: "InfoProtection",
};
</script>

<style scoped lang="scss">
$color-ink: #17233d;
$color-body: #33415c;
$color-accent: #0060ff;
$color-border: #e2e8f0;

.protection-page {
  min-height: 100vh;
  width: 100%;
  padding: 3rem 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: linear-gradient(160deg, #eef3fb 0%, #f7f9fc 55%, #ffffff 100%);
}

.protection-card {
  width: 100%;
  max-width: 46rem;
  background: #ffffff;
  border: 1px solid $color-border;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(15, 30, 60, 0.08);
  padding: 2.75rem clamp(1.5rem, 5vw, 3.5rem);
  color: $color-body;
  line-height: 1.65;
  font-size: 1.05rem;
}

.protection-eyebrow {
  margin: 0 0 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.8rem;
  font-weight: 700;
  color: $color-accent;
}

.protection-title {
  margin: 0 0 1.25rem;
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  font-weight: 700;
  color: $color-ink;
  letter-spacing: -0.01em;
}

.protection-lede {
  font-size: 1.1rem;
  color: $color-ink;
}

.protection-heading {
  margin: 2rem 0 1rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: $color-ink;
  padding-top: 1.5rem;
  border-top: 1px solid $color-border;
}

p {
  margin: 0 0 1.1rem;
}

a {
  color: $color-accent;
  font-weight: 600;
  text-decoration: underline;

  &:hover,
  &:focus-visible {
    text-decoration-thickness: 2px;
  }

  &:focus-visible {
    outline: 2px solid $color-accent;
    outline-offset: 2px;
  }
}

.protection-list {
  margin: 0;
  padding-left: 1.35rem;
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.protection-list li {
  padding-left: 0.25rem;
}

@media (max-width: 40rem) {
  .protection-page {
    padding: 1.5rem 0.75rem;
  }

  .protection-card {
    padding: 2rem 1.25rem;
    font-size: 1rem;
  }
}
</style>
